export default __webpack_public_path__ + "static/media/workChat.f2df86c4.svg";